<!-- <title>Invoice</title> -->
<style>
  body {
    font-family: Booton;
    margin: 40px;
    background: #fff;
  }

  .invoice-container {
    padding: 40px;
    max-width: 800px;
    margin: auto;
    color: var(--green-900);
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: var(--green-700);
    font-family: ABC Arizona Flare;
    font-weight: 300;

    .invoice-number {
      font-size: 20px;
      font-weight: 400;
    }
  }

  h1 {
    margin: 0 0 10px 0;
  }

  .merchant-info-box {
    border: 1px solid var(--green-700);
    padding: 20px 40px;
    text-align: center;
    font-size: 15px;
    color: var(--green-900);
    background-color: var(--green-100);
  }

  .bill-section {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Booton;

    .bill-to {
      font-size: 13px;
      font-weight: 300;
    }

    .customer-email {
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }

  .invoice-meta {
    font-size: 16px;
  }

  .due {
    color: var(--green-700);
    font-size: 16px;
    font-weight: 650;
  }

  table {
    margin-top: 10px;
    width: 100%;
    border-spacing: 0;
    border: 1px solid var(--gray-200);

    .table-header-row {
      background-color: var(--table-header-gray);
      height: 48px;
      th {
        font-family: Booton;
          font-size: 13px;
          font-weight: 500;
          color: var(--gray-900);
          padding: 0 16px;
          text-align: left;
          cursor: pointer;
          white-space: nowrap;
          border-bottom: 1px solid var(--gray-200);
      }
    }

    .table-row {
      background-color: var(--white);
      td {
        font-family: Booton;
        font-size: 13px;
        color: var(--gray-900);
        padding: 8px 16px;
        border-bottom: none;
        box-shadow: inset 0 -1px 0 0 var(--gray-200);
      }
    }
  }

  .totals {
    margin-top: 50px;
    text-align: right;
    font-size: 16px;
    font-family: Booton;
  }

  .grand-total {
    border-top: 1px solid var(--green-800);
    font-size: 20px;
    font-weight: bold;
    text-align: right;
    margin-top: 20px;
    padding-top: 20px;
  }

  .invoice-info {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 400;
    color: var(--green-900);
  }

  .invoice-message {
    color: var(--green-700);
    text-align: center;
  }
</style>

<div class="invoice-container">
  <div class="header">
    <div>
      <span class="invoice-number">INVOICE #{{ invoice.number }}</span>
      <div class="invoice-info">
        <span>{{ currentDate }}</span>
      </div>
    </div>

    <div class="merchant-info-box">
      <strong>{{ merchantName }}</strong
      ><br />
      {{ merchantEmail }}<br />
      {{ merchantPhone }}
    </div>
  </div>

  <br/><br/>

  <div class="bill-section">
    <div>
      <span class="bill-to">bill to:</span><br />
      <span>{{ customerName }}</span
      ><br />
      <span class="customer-email">{{ customerEmail }}</span><br />
    </div>
    <div class="due">DUE: {{ dueDate }}</div>
  </div>

  <br />

  <table>
    <tr class="table-header-row">
      <th>Item</th>
      <th>Quantity</th>
      <th>Unit Price</th>
      <th>Total</th>
    </tr>
    @for (item of invoice.invoiceItems; track item) {
      <tr class="table-row">
        <td>{{ item.name }}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ uiHelpers.formatCurrencyToString(item.unitPrice) }}</td>
        <td>
          {{ uiHelpers.formatCurrencyToString(item.unitPrice * item.quantity) }}
        </td>
      </tr>
    }
  </table>

  <div class="totals">
    <div>
      Sub-total: {{ uiHelpers.formatCurrencyToString(subTotal) }}
    </div>
    <div>Tax: {{ uiHelpers.formatCurrencyToString(tax) }}</div>
  </div>

  <div class="grand-total">
    Total Due:
    {{ uiHelpers.formatCurrencyToString(invoice.totalAmtDue) }}
  </div>

  <br />

  <div>
    <p class="invoice-message">
      <span>{{ customMessage }}</span><br />
      <br />
      <span>
        For further inquiries please contact the merchant at {{ merchantEmail }}
      </span>
    </p>
  </div>

  <div
    style="
      display: flex;
      gap: 20px;
      align-items: center;
      justify-content: center;
      margin-top: 80px;
    "
  >
    <input
      style="width: 150px;"
      type="button"
      value="Cancel"
      class="btn-secondary"
      (click)="handleCancelClicked()"
    />
    <input
      style="width: 150px;"
      type="button"
      value="Send Invoice"
      class="btn-primary"
      (click)="handleSendClicked()"
    />
  </div>
</div>
